export default (thePizza, cartItem) => {
    
    let itemPrice = 0.00;

    if (thePizza.prices) {
        // get the price for the size
        thePizza.prices.forEach((thePrice) => {
            if (thePrice.id == cartItem.price_id) {
                itemPrice += parseFloat(thePrice.price);
            }
        });
    }

    if (thePizza.toppings) {
        // get the prices for the toppings
        cartItem.toppings.forEach((theCartTopping) => {
            thePizza.toppings.forEach((theTopping) => {
                if (theTopping.id == theCartTopping.id) {
                    theTopping.prices.forEach((thePrice) => {
                        if (thePrice.size_id == cartItem.price_id) {
                            if (theCartTopping.isdefault && theCartTopping.amount == "extra") {
                                itemPrice += parseFloat(thePrice.price);
                            }
                            else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {
                                itemPrice += parseFloat(thePrice.price);
                            }
                        }
                    });
                }
            });
        });
    }

    if (thePizza.crusts) {
        // get the price for the crust
        thePizza.crusts.forEach((theCrust) => {
            if (theCrust.id == cartItem.crust_id) {
                theCrust.prices.forEach((thePrice) => {
                    if (thePrice.size_id == cartItem.price_id) {
                        itemPrice += parseFloat(thePrice.price);
                    }
                });
            }
        });
    }

    if (thePizza.sauces) {
        // get the price for the sauce
        thePizza.sauces.forEach((theSauce) => {
            if (theSauce.id == cartItem.sauce_id) {
                theSauce.prices.forEach((thePrice) => {
                    if (thePrice.size_id == cartItem.price_id) {
                        itemPrice += parseFloat(thePrice.price);
                    }
                });
            }
        });
    }

    itemPrice *= cartItem.quantity;
    
    return itemPrice;
}